import { render, staticRenderFns } from "./ListRastreamentoView.vue?vue&type=template&id=f265350a&"
import script from "./ListRastreamentoView.vue?vue&type=script&lang=ts&"
export * from "./ListRastreamentoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports